module.exports = __webpack_public_path__ + "media/images/default/pages/public_science_1/2-138e57abd33960eed7594fba20dcf53a.jpeg";